/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Who can participate in this gamification
 * @export
 */
export const GamificationEligibilityMode = {
    OPEN: 'OPEN',
    HOST_MEMBERS: 'HOST_MEMBERS',
    INVITE_ONLY: 'INVITE_ONLY',
    PREREQUISITE: 'PREREQUISITE',
    CHALLENGE_PRIZE_ELIGIBLE: 'CHALLENGE_PRIZE_ELIGIBLE',
    EXPERIENCE_MEMBERS: 'EXPERIENCE_MEMBERS'
} as const;
export type GamificationEligibilityMode = typeof GamificationEligibilityMode[keyof typeof GamificationEligibilityMode];


export function instanceOfGamificationEligibilityMode(value: any): boolean {
    for (const key in GamificationEligibilityMode) {
        if (Object.prototype.hasOwnProperty.call(GamificationEligibilityMode, key)) {
            if (GamificationEligibilityMode[key as keyof typeof GamificationEligibilityMode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function GamificationEligibilityModeFromJSON(json: any): GamificationEligibilityMode {
    return GamificationEligibilityModeFromJSONTyped(json, false);
}

export function GamificationEligibilityModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): GamificationEligibilityMode {
    return json as GamificationEligibilityMode;
}

export function GamificationEligibilityModeToJSON(value?: GamificationEligibilityMode | null): any {
    return value as any;
}

export function GamificationEligibilityModeToJSONTyped(value: any, ignoreDiscriminator: boolean): GamificationEligibilityMode {
    return value as GamificationEligibilityMode;
}

